import React from 'react';
import axios from "axios";
import { useState, useEffect } from 'react';
import AdminHeaderNew from '../NewAdminPanel/Common/AdminHeader';
import AdminSideBarMnt from '../NewAdminPanel/Common/AdminSidebarMnt';
import AdminFooterNew from '../NewAdminPanel/Common/AdminFooter';
import { useNavigate, useLocation } from "react-router-dom";
import { MultiSelect } from "react-multi-select-component";

const AtariUserCreation = () => {
    const navigate = useNavigate();
    const { state } = useLocation();
    
    // Base URL from environment variables
    const baseUrl = `${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}`;
    
    // Basic user information
    const [userNameValue, setUserNameValue] = useState("");
    const [mobileValue, setMobileValue] = useState("");
    const [emailValue, setEmailValue] = useState("");
    const [designationValue, setDesignationValue] = useState("");
    const [gender, setGender] = useState('');
    const [userCodeLocal, setUserCodeLocal] = useState("");
    const [addressValue, setAddressValue] = useState("");
    const [userTypeValue, setUserTypeValue] = useState("");
    const [userRoleValue, setUserRoleValue] = useState("");

    // Handle user type change
    const handleUserTypeChange = (e) => {
        const newUserType = e.target.value;
        setUserTypeValue(newUserType);
        
        // Reset atari value when switching away from Atari
        if (newUserType !== "10") {
            setAtariValue("NA");
        } else {
            // When switching to Atari, also reset to NA
            setAtariValue("NA");
        }
        
        // Set role based on user type
        if (newUserType && newUserType !== "NA") {
            switch(newUserType) {
                case "10":
                    setUserRoleValue("Atari");
                    break;
                case "5":
                    setUserRoleValue("Surveyor");
                    break;
                default:
                    setUserRoleValue("");
            }
        } else {
            setUserRoleValue("");
        }
    };
    
    // Atari, State and District related
    const [atariValue, setAtariValue] = useState("NA");
    const [stateValue, setStateValue] = useState("NA");
    const [districtValue, setDistrictValue] = useState("");  // Single selection
    const [blockValue, setBlockValue] = useState([]); // Changed to array for multiple selection
    const [blockOptions, setBlockOptions] = useState([]);
    const [selectedBlocks, setSelectedBlocks] = useState([]);
    
    // Data arrays
    const [atariData, setAtariData] = useState([]);
    const [statesData, setStatesData] = useState([]);
    const [districtsData, setDistrictsData] = useState([]);
    const [blocksData, setBlocksData] = useState([]);
    const [designationData, setDesignationData] = useState([]);
    
    // Validation and UI states
    const [isStateAutoSelected, setIsStateAutoSelected] = useState(false);
    const [validationErrors, setValidationErrors] = useState({});

    useEffect(() => {
    //  alert(sessionStorage.getItem("userNameModel"));
        // Get user information from session storage
        const userCode = sessionStorage.getItem("userCode") || sessionStorage.getItem("userCodeModel");
        const userName = sessionStorage.getItem("userNameModel") || sessionStorage.getItem("userNameModel");
        //const schemeCode=sessionStorage.getItem("schemeCodeModel");
        const schemeCode = sessionStorage.getItem("schemeCodeModel") || "16";
        if (userCode && userName) {
            // Ensure consistent session storage keys
            sessionStorage.setItem("userNameModel", userName);
            sessionStorage.setItem("userCodeModel", userCode);
            sessionStorage.setItem("schemeCodeModel", "16"); // M&T scheme
            
            // User name will not be auto-filled
        } else {
            console.error("No user session found");
            navigate("/login");
            return;
        }

        // Fetch required data
        fetchDesignation();
        fetchAtariData();
        fetchStates();
    }, []);

    useEffect(() => {
        if (stateValue && stateValue !== "NA") {
            console.log("State selected:", stateValue, "- Fetching districts...");
            fetchDistricts(stateValue);
        } else {
            console.log("No state selected or state is NA, clearing districts");
            setDistrictsData([]);
            setDistrictValue("");
        }
    }, [stateValue]);

    useEffect(() => {
        // useEffect to set defaultValue in dropdown menu for edit mode
        if (state) {
            console.log("state$$$", state)
            setUserNameValue(state.cropSurveyCode.userName);
            setMobileValue(state.cropSurveyCode.mobile);
            setEmailValue(state.cropSurveyCode.emailId || "");
            setDesignationValue(state.cropSurveyCode.designationCode);
            setUserCodeLocal(state.cropSurveyCode.userCode);
            setGender(state.cropSurveyCode.gender);
            setAtariValue(state.cropSurveyCode.atariCode);
            setStateValue(state.cropSurveyCode.stateCode);
            setDistrictValue(state.cropSurveyCode.districtCode);
            setAddressValue(state.cropSurveyCode.address || "");
        }
    }, []);

    const fetchDesignation = async () => {
        try {
            const result = await axios(
                `${
                    process.env.NODE_ENV === "development"
                        ? process.env.REACT_APP_DEV_MODE
                        : process.env.REACT_APP_PRO_MODE
                }/api/Management/commDesignation`
            );
            setDesignationData(result.data.dataContent);
        } catch (error) {
            console.error("Error fetching designations:", error);
        }
    };

    const fetchAtariData = async () => {
        try {
            console.log("Fetching Atari data...");
            const response = await axios.get(
                `${baseUrl}/api/MT/GetAtari`
            );
            
            console.log("Atari API response:", response.data);
            if (response.data && response.data.dataContent) {
                const atariList = response.data.dataContent;
                console.log("Atari data loaded:", atariList);
                setAtariData(atariList);
            } else {
                console.error("Invalid or empty Atari data received");
                alert("Error loading Atari data. Please try refreshing the page.");
            }
        } catch (error) {
            console.error("Error fetching Atari data:", error);
            alert("Error loading Atari data. Please try refreshing the page.");
        }
    };

    const fetchStates = async () => {
        try {
            const result = await axios(
                `${
                    process.env.NODE_ENV === "development"
                        ? process.env.REACT_APP_DEV_MODE
                        : process.env.REACT_APP_PRO_MODE
                }/api/states`
            );
            // Show all states
            const allStates = result.data.dataContent;
            console.log("All states:", allStates);
            setStatesData(allStates);
        } catch (error) {
            console.error("Error fetching states:", error);
        }
    };

    const fetchDistricts = async (stateCode) => {
        try {
            console.log("Fetching districts for state code:", stateCode);
            
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");

            var raw = JSON.stringify({
                stateCode: Number(stateCode),
            });

            var requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: raw,
                redirect: "follow",
            };

            const response = await fetch(
                `${
                    process.env.NODE_ENV === "development"
                        ? process.env.REACT_APP_DEV_MODE
                        : process.env.REACT_APP_PRO_MODE
                }/api/district`,
                requestOptions
            );
            
            const result = await response.text();
            const jsonResult = JSON.parse(result);
            console.log("Districts API response:", jsonResult);
            
            if (jsonResult && jsonResult.dataContent) {
                setDistrictsData(jsonResult.dataContent);
                console.log("Districts set successfully:", jsonResult.dataContent.length, "districts");
            } else {
                console.log("No districts data received, setting empty array");
                setDistrictsData([]);
            }
        } catch (error) {
            console.error("Error fetching districts:", error);
            // Don't break the component, just set empty districts
            setDistrictsData([]);
            alert("Error loading districts. Please try again.");
        }
    };

    // Modify fetchBlocks to accumulate blocks instead of replacing them
    const fetchBlocks = async (districtCode) => {
        try {
            console.log("Fetching blocks for district code:", districtCode);
            
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");

            var raw = JSON.stringify({
                blockCode: 0,
                blockName: "",
                subDistrictCode: 0,
                districtCode: Number(districtCode),
                visibility: 1
            });

            var requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: raw,
                redirect: "follow",
            };

            const response = await fetch(
                `${
                    process.env.NODE_ENV === "development"
                        ? process.env.REACT_APP_DEV_MODE
                        : process.env.REACT_APP_PRO_MODE
                }/api/block`,
                requestOptions
            );
            
            const result = await response.text();
            const jsonResult = JSON.parse(result);
            
            if (jsonResult && jsonResult.dataContent) {
                // Format blocks data for MultiSelect
                const newBlocks = jsonResult.dataContent.map(block => ({
                    label: block.blockName,
                    value: block.blockCode.toString(),
                    districtCode: block.districtCode.toString()
                }));
                
                // Merge with existing blocks, removing duplicates
                setBlockOptions(prevBlocks => {
                    const existingBlockCodes = new Set(prevBlocks.map(b => b.value));
                    const uniqueNewBlocks = newBlocks.filter(b => !existingBlockCodes.has(b.value));
                    return [...prevBlocks, ...uniqueNewBlocks];
                });
            }
        } catch (error) {
            console.error("Error fetching blocks:", error);
            alert("Error loading blocks. Please try again.");
        }
    };

    async function ValidateAddUser() {
        console.log("ValidateAddUser function called");
        console.log("Current values:", {
            userTypeValue,
            atariValue,
            userNameValue,
            addressValue,
            designationValue,
            mobileValue,
            emailValue,
            gender,
            stateValue,
            districtValue,
            selectedBlocks
        });
        
        try {
            // User Type validation
            if(!userTypeValue || userTypeValue === "" || userTypeValue === "NA") {
                alert("Please select a User Type");
                return;
            }

            // Atari validation - only required when user type is Atari
            if(userTypeValue === "10" && (!atariValue || atariValue === "" || atariValue === "NA" || atariValue === "Choose...")) {
                console.log("Atari validation failed. atariValue:", atariValue);
                alert("Please select an Atari");
                return;
            }

            // User name validation
            if(userNameValue === "" || userNameValue.trim() === "") {
                alert("Please enter a valid user name");
                return;
            }

            // Address validation - required field
            if(addressValue === "" || addressValue.trim() === "") {
                alert("Please enter a valid address");
                return;
            }

            // Designation validation
            if(designationValue === "Choose..." || designationValue === "") {
                alert("Please select a designation");
                return;
            }

            // Mobile validation
            if(mobileValue === "" || mobileValue.length !== 10) {
                alert("Please enter a valid 10-digit mobile number");
                return;
            }

            // Email validation (optional but if provided should be valid)
            if(emailValue && emailValue.trim() !== "" && !validateEmail(emailValue)) {
                alert("Please enter a valid Email ID");
                return;
            }

            // Gender validation
            if(gender === "") {
                alert("Please select a gender");
                return;
            }

            // State validation - required for Surveyor
            if(userTypeValue === "5" && (!stateValue || stateValue === "NA")) {
                alert("Please select a State");
                return;
            }

            // District validation - required for Surveyor
            if(userTypeValue === "5" && (!districtValue || districtValue === "")) {
                alert("Please select a District");
                return;
            }

            // Block validation - required for Surveyor
            if(userTypeValue === "5" && (!selectedBlocks || selectedBlocks.length === 0)) {
                alert("Please select at least one Block");
                return;
            }

            console.log("All validations passed, calling", state ? "UpdateUser" : "AddNewUser");
            state ? UpdateUser() : AddNewUser();
        } catch (error) {
            console.error("Error in ValidateAddUser:", error);
            alert("An error occurred during validation. Please check console for details.");
        }
    }

    function validateEmail(email) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    }

    // Validation functions
    const validateField = (fieldName, value) => {
        const errors = { ...validationErrors };
        
        switch (fieldName) {
            case 'state':
                if (!value || value === "NA") {
                    errors.state = "Please select a State";
                } else {
                    delete errors.state;
                }
                break;
                
            case 'district':
                if (!value || value === "" || value === "NA") {
                    errors.district = "Please select a District";
                } else {
                    delete errors.district;
                }
                break;
                
            case 'block':
                if (userTypeValue === "5" && (!value || value.length === 0)) {
                    errors.block = "Please select at least one Block";
                } else {
                    delete errors.block;
                }
                break;
                
            default:
                break;
        }
        
        setValidationErrors(errors);
        return Object.keys(errors).length === 0;
    };

    const handleAddress = (e) => {
        setAddressValue(e.target.value);
    };

    function AddNewUser() {
        console.log("AddNewUser function called");
        
        try {
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");

            // Get user code from session storage with validation
            const currentUserCode = sessionStorage.getItem("userCodeModel");
            if (!currentUserCode || currentUserCode === "null") {
                alert("Session expired. Please login again.");
                navigate("/mapLogin");
                return;
            }
            // Current date for timestamp fields
            const currentDate = new Date().toISOString();

            // Create payload for Atari user
            // Helper function to convert NA to 0 for integer fields
            const convertToInt = (value) => {
                if (!value || value === "NA" || value === "Choose..." || value === "") {
                    return "0";
                }
                return String(value);
            };

            const payload = {
                "createdOnByUC": currentDate,
                "createdByUC": Number(currentUserCode),
                "modifiedOnByUC": currentDate,
                "modifiedByUC": Number(currentUserCode),
                "userRoleCode": getRoleCodeFromUserLevel(userTypeValue), // Atari user role
                "address": addressValue,
                "userCode": 0,
                "userName": userNameValue,
                "userId": mobileValue,
                "mobile": mobileValue,
                "password": "",
                "passwordNew": "",
                "passwordConfirm": "",
                "emailId": emailValue,
                "gender": gender,
                "aadhar": "",
                "departmentCode": "1",
                "designationCode": String(designationValue),
                "stateCode": convertToInt(stateValue),
                "districtCode": convertToInt(districtValue),
                "subDistrictCode": "",
                "blockCode": "0",
                "villageCode": "",
                "userTypeCode": sessionStorage.getItem("userTypeCodeModel"), // User type from selection
                "schemeCode": "16", // M&T scheme
                "isVisible": "Y",
                "isActive": "Y",
                "lastLoginOn": currentDate,
                "otp": "",
                "custumMessage": "",
                "isMobileVerified": "N",
                "isEmailVerified": "N",
                "orgTypeCode": "1",
                "insuranceCompanyCode": "",
                "fmttiCode": 0,
                "fmtcCode": 0,
                "atariCode": userTypeValue === "10" ? Number(atariValue === "NA" ? 0 : atariValue) : 0,
                "kvkCode": 0
            };
            
            console.log("=== API Payload ===");
            console.log(JSON.stringify(payload, null, 2));
            
            var raw = JSON.stringify(payload);

            var requestOptions = {
              method: "POST",
              headers: myHeaders,
              body: raw,
              redirect: "follow",
            };

            const apiUrl = `${baseUrl}/api/MT/Users`;
            console.log("=== Making API Call ===");
            console.log("URL:", apiUrl);
            console.log("Method: POST");
            
            fetch(apiUrl, requestOptions)
              .then(async (response) => {
                console.log("=== API Response Received ===");
                console.log("Status:", response.status);
                console.log("Status Text:", response.statusText);
                console.log("Headers:", response.headers);
                
                const responseText = await response.text();
                console.log("Raw Response:", responseText);
                
                return {
                    status: response.status,
                    statusText: response.statusText,
                    text: responseText,
                    ok: response.ok
                };
              })
              .then((responseData) => {
                console.log("=== Processing Response ===");
                console.log("Response Data:", responseData);
                
                try {
                    if (responseData.text && responseData.text.trim()) {
                        const jsonResult = JSON.parse(responseData.text);
                        console.log("Parsed JSON Response:", jsonResult);
                        
                        // Handle different response structures
                        const message = jsonResult.message || 
                                      jsonResult.msg || 
                                      jsonResult.responseMessage || 
                                      jsonResult.statusMessage ||
                                      `API returned status ${responseData.status}: ${responseData.statusText}`;
                        
                        console.log("Extracted message:", message);
                        console.log("Response success field:", jsonResult.success);
                        console.log("Response status field:", jsonResult.status);
                        console.log("Response statusCode field:", jsonResult.statusCode);
                        console.log("Response ok:", responseData.ok);
                        
                        // Check for success - only navigate if explicitly successful
                        const isSuccess = (jsonResult.success === true || jsonResult.success === "true") && 
                                        responseData.ok && 
                                        responseData.status >= 200 && 
                                        responseData.status < 300;
                        
                        console.log("Final success determination:", isSuccess);
                        
                        if (isSuccess) {
                            console.log("Atari User created successfully, navigating to user list");
                            alert("Atari User created successfully!");
                            navigate("/MNT/UsrListMnt");
                        } else {
                            console.log("User creation failed or returned error, staying on current page");
                            
                            // Check for specific error messages
                            let errorMessage = "Failed to create Atari user.";
                            
                            if (message) {
                                if (message.toLowerCase().includes("mobile") && message.toLowerCase().includes("exist")) {
                                    errorMessage = "A user with this mobile number already exists. Please use a different mobile number.";
                                } else if (message.toLowerCase().includes("email") && message.toLowerCase().includes("exist")) {
                                    errorMessage = "A user with this email address already exists. Please use a different email address.";
                                } else if (message.toLowerCase().includes("user") && message.toLowerCase().includes("exist")) {
                                    errorMessage = "A user with this information already exists. Please check the details and try again.";
                                } else {
                                    errorMessage = message;
                                }
                            }
                            
                            alert(errorMessage);
                        }
                    } else {
                        console.error("Empty response received");
                        alert(`API call completed with status ${responseData.status}, but no response body received. Please check server logs.`);
                    }
                } catch (parseError) {
                    console.error("Error parsing API response:", parseError);
                    console.error("Raw response was:", responseData.text);
                    alert(`Server returned status ${responseData.status}. Response could not be parsed as JSON. Check console for details.`);
                }
              })
              .catch((error) => {
                console.error("=== API Call Error ===");
                console.error("Error:", error);
                console.error("Error message:", error.message);
                console.error("Error stack:", error.stack);
                alert("Network error occurred while creating user. Please check your connection and try again.");
              });
        } catch (error) {
            console.error("=== Function Error ===");
            console.error("Error in AddNewUser:", error);
            alert("An unexpected error occurred. Please check console for details and try again.");
        }
    }

    function UpdateUser() {
        console.log("UpdateUser function called");
        
        try {
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");

            // Get user code from session storage with validation
            const currentUserCode = sessionStorage.getItem("userCodeModel");
            if (!currentUserCode || currentUserCode === "null") {
                alert("Session expired. Please login again.");
                navigate("/mapLogin");
                return;
            }

            // Current date for timestamp fields
            const currentDate = new Date().toISOString();

            // Helper function to convert NA to 0 for integer fields
            const convertToInt = (value) => {
                if (!value || value === "NA" || value === "Choose..." || value === "") {
                    return "0";
                }
                return String(value);
            };

            // Create payload for Atari user update
            const payload = {
                "createdOnByUC": currentDate,
                "createdByUC": Number(currentUserCode),
                "modifiedOnByUC": currentDate,
                "modifiedByUC": Number(currentUserCode),
                "userRoleCode": getRoleCodeFromUserLevel(userTypeValue), // Atari user role
                "address": addressValue,
                "userCode": Number(userCodeLocal),
                "userName": userNameValue,
                "userId": mobileValue,
                "mobile": mobileValue,
                "password": "",
                "passwordNew": "",
                "passwordConfirm": "",
                "emailId": emailValue,
                "gender": gender,
                "aadhar": "",
                "departmentCode": "1",
                "designationCode": String(designationValue),
                "stateCode": convertToInt(stateValue),
                "districtCode": convertToInt(districtValue),
                "subDistrictCode": "",
                "blockCode": "0",
                "villageCode": "",
                "userTypeCode": sessionStorage.getItem("userTypeCodeModel"), // User type from selection
                "schemeCode": "16", // M&T scheme
                "isVisible": "Y",
                "isActive": "Y",
                "lastLoginOn": currentDate,
                "otp": "",
                "custumMessage": "",
                "isMobileVerified": "N",
                "isEmailVerified": "N",
                "orgTypeCode": "1",
                "insuranceCompanyCode": "",
                "fmttiCode": 0,
                "fmtcCode": 0,
                "atariCode": userTypeValue === "10" ? Number(atariValue === "NA" ? 0 : atariValue) : 0,
                "kvkCode": 0
            };
            
            console.log("=== Update API Payload ===");
            console.log(JSON.stringify(payload, null, 2));
            
            var raw2 = JSON.stringify(payload);

            var requestOptions = {
              method: "PUT",
              headers: myHeaders,
              body: raw2,
              redirect: "follow",
            };

            const apiUrl = `${baseUrl}/api/MT/Users`;
            console.log("=== Making Update API Call ===");
            console.log("URL:", apiUrl);
            console.log("Method: PUT");
            
            fetch(apiUrl, requestOptions)
              .then(async (response) => {
                console.log("=== Update API Response Received ===");
                console.log("Status:", response.status);
                console.log("Status Text:", response.statusText);
                
                const responseText = await response.text();
                console.log("Raw Response:", responseText);
                
                return {
                    status: response.status,
                    statusText: response.statusText,
                    text: responseText,
                    ok: response.ok
                };
              })
              .then((responseData) => {
                console.log("=== Processing Update Response ===");
                console.log("Response Data:", responseData);
                
                try {
                    if (responseData.text && responseData.text.trim()) {
                        const jsonResult = JSON.parse(responseData.text);
                        console.log("Parsed JSON Response:", jsonResult);
                        
                        // Handle different response structures
                        const message = jsonResult.message || 
                                      jsonResult.msg || 
                                      jsonResult.responseMessage || 
                                      jsonResult.statusMessage ||
                                      `API returned status ${responseData.status}: ${responseData.statusText}`;
                        
                        console.log("Extracted message:", message);
                        console.log("Response success field:", jsonResult.success);
                        console.log("Response status field:", jsonResult.status);
                        console.log("Response statusCode field:", jsonResult.statusCode);
                        console.log("Response ok:", responseData.ok);
                        
                        // Check for success - only navigate if explicitly successful
                        const isSuccess = (jsonResult.success === true || jsonResult.success === "true") && 
                                        responseData.ok && 
                                        responseData.status >= 200 && 
                                        responseData.status < 300;
                        
                        console.log("Final success determination:", isSuccess);
                        
                        if (isSuccess) {
                            console.log("Atari User updated successfully, navigating to user list");
                            alert("Atari User updated successfully!");
                            navigate("/MNT/UsrListMnt");
                        } else {
                            console.log("User update failed or returned error, staying on current page");
                            
                            // Check for specific error messages
                            let errorMessage = "Failed to update Atari user.";
                            
                            if (message) {
                                if (message.toLowerCase().includes("mobile") && message.toLowerCase().includes("exist")) {
                                    errorMessage = "A user with this mobile number already exists. Please use a different mobile number.";
                                } else if (message.toLowerCase().includes("email") && message.toLowerCase().includes("exist")) {
                                    errorMessage = "A user with this email address already exists. Please use a different email address.";
                                } else if (message.toLowerCase().includes("user") && message.toLowerCase().includes("exist")) {
                                    errorMessage = "A user with this information already exists. Please check the details and try again.";
                                } else {
                                    errorMessage = message;
                                }
                            }
                            
                            alert(errorMessage);
                        }
                    } else {
                        console.error("Empty response received");
                        alert(`API call completed with status ${responseData.status}, but no response body received. Please check server logs.`);
                    }
                } catch (parseError) {
                    console.error("Error parsing API response:", parseError);
                    console.error("Raw response was:", responseData.text);
                    alert(`Server returned status ${responseData.status}. Response could not be parsed as JSON. Check console for details.`);
                }
              })
              .catch((error) => {
                console.error("=== Update API Call Error ===");
                console.error("Error:", error);
                console.error("Error message:", error.message);
                alert("Network error occurred while updating user. Please check your connection and try again.");
              });
        } catch (error) {
            console.error("=== Update Function Error ===");
            console.error("Error in UpdateUser:", error);
            alert("An unexpected error occurred during update. Please check console for details and try again.");
        }
    }

    function handleMobileNumber(value) {
        const valueFinal = value.replace(/\D/g, "").replace(/^0/, "").replace(/^1/, "").replace(/^2/, "").replace(/^3/, "").replace(/^4/, "").replace(/^5/, "");
        setMobileValue(valueFinal)
    }

    function validateMobile() {
       if (mobileValue.length === 10) {
          document.getElementById("mobilenumber").style.borderColor = "green";
        } else {
          document.getElementById("mobilenumber").style.borderColor = "red";
        }
    }

    function handleUserName(e) {
      let localText = e.target.value.replace(/[^\w\s]/gi, "")
      console.log("Setting userName to:", localText);
      setUserNameValue(localText)
    }

    function handleEmail(e) {
        setEmailValue(e.target.value);
    }

    // Helper function to get role code based on user type
    function getRoleCodeFromUserLevel(userType) {
        switch(userType) {
            case "10":
                return "10"; // Atari role code
            case "5":
                return "5"; // Surveyor role code
            default:
                return "10"; // Default to Atari
        }
    }

    // Handler functions for state/district/block changes
    const handleStateChange = (e) => {
        const selectedState = e.target.value;
        setStateValue(selectedState);
        validateField('state', selectedState);
    };


    // Add handler for block selection
    const handleBlockChange = (selected) => {
        setSelectedBlocks(selected);
        setBlockValue(selected.map(item => item.value));
        validateField('block', selected);
    };

    return (
        <>
            <AdminHeaderNew />
            <AdminSideBarMnt /> 
            <main id="main" className="main">
                <div className="pagetitle">
                    <h1>Atari User Creation</h1>
                    <nav>
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">Admin</li>
                            <li className="breadcrumb-item active">Atari User Creation</li>
                            <li className="breadcrumb-item">{(sessionStorage.getItem("userNameModel"))}</li>
                        </ol>
                    </nav>
                </div>

                <section className="section dashboard newAdminForms">
                    <div className='row'>
                        <div className='col-md-12'>
                            <div className='card'>
                                <div className='card-body'>
                                    <div className='row'>
                                        <div className='col-md-4'>
                                            <label className="form-label">User Type</label><label style={{color : "red"}}>*</label>
                                            <select 
                                                className='form-select' 
                                                value={userTypeValue}
                                                onChange={handleUserTypeChange}
                                            >
                                                <option value="NA">Choose...</option>
                                                <option value="10">Atari</option>
                                                {/* <option value="5">Surveyor</option> */}
                                            </select>
                                        </div>
                                         {/* Role - Show when User Level is selected */}
                                         {userTypeValue && userTypeValue !== "Choose..." && (
                                            <div className="col-md-4">
                                                <label className="form-label">Role</label><label style={{color : "red"}}>*</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={userRoleValue}
                                                    disabled
                                                />
                                            </div>
                                        )}
                                       
                                        
                                        {/* State Name */}
                                        {(userTypeValue === "5") && (
                                            <div className='col-md-4'>
                                                <label className="form-label">State Name</label><label style={{color : "red"}}>*</label>
                                                <select 
                                                    className={`form-select ${validationErrors.state ? 'is-invalid' : ''}`}
                                                    value={stateValue}
                                                    onChange={handleStateChange}
                                                    disabled={isStateAutoSelected}
                                                    style={isStateAutoSelected ? { backgroundColor: '#e9ecef', cursor: 'not-allowed' } : {}}
                                                > 
                                                    <option value={"NA"}>Choose...</option>
                                                    {statesData.map((item, id) => (
                                                        <option key={id} value={item.stateCode}>
                                                            {item.stateName}
                                                        </option>
                                                    ))}
                                                </select>
                                                {validationErrors.state && (
                                                    <div className="invalid-feedback d-block">
                                                        {validationErrors.state}
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                        
                                         {/* District Selection */}
                                         {(userTypeValue ==="5") && (
                                             <div className='col-md-4'>
                                                 <label className="form-label">District Name</label><label style={{color : "red"}}>*</label>
                                                 <select 
                                                     className={`form-select ${validationErrors.district ? 'is-invalid' : ''}`}
                                                     value={districtValue}
                                                     onChange={(e) => {
                                                         const selectedDistrictCode = e.target.value;
                                                         setDistrictValue(selectedDistrictCode);
                                                         
                                                         // Clear blocks and fetch new ones for selected district
                                                         setSelectedBlocks([]);
                                                         setBlockValue([]);
                                                         setBlockOptions([]);
                                                         
                                                         if (selectedDistrictCode) {
                                                             fetchBlocks(selectedDistrictCode);
                                                         }
                                                         
                                                         validateField('district', selectedDistrictCode);
                                                     }}
                                                     disabled={!stateValue || stateValue === "NA"}
                                                 >
                                                     <option value="">Choose...</option>
                                                     {districtsData.map((district, id) => (
                                                         <option key={id} value={district.districtCode}>
                                                             {district.districtName}
                                                         </option>
                                                     ))}
                                                 </select>
                                                 {validationErrors.district && (
                                                     <div style={{color: 'red', fontSize: '0.875em', marginTop: '4px'}}>
                                                         {validationErrors.district}
                                                     </div>
                                                 )}
                                             </div>
                                         )}

                                        {/* Block Name - Show for Surveyor only */}
                                        {(userTypeValue === "5") && (
                                            <div className='col-md-4'>
                                                <label className="form-label">Block Name</label><label style={{color : "red"}}>*</label>
                                                <MultiSelect
                                                    options={blockOptions.filter(block => 
                                                        districtValue && block.districtCode === districtValue.toString()
                                                    )}
                                                    value={selectedBlocks}
                                                    onChange={handleBlockChange}
                                                    labelledBy="Select Blocks"
                                                    disabled={!districtValue || districtValue === ""}
                                                />
                                                {validationErrors.block && (
                                                    <div style={{color: 'red', fontSize: '0.875em', marginTop: '4px'}}>
                                                        {validationErrors.block}
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                        {/* Select Atari - Only show when Atari is selected */}
                                        {userTypeValue === "10" && (
                                            <div className='col-md-4'>
                                                <label className="form-label">Select Atari</label><label style={{color : "red"}}>*</label>
                                                <select 
                                                    className='form-select' 
                                                    value={atariValue}
                                                    onChange={(e) => setAtariValue(e.target.value)}
                                                >
                                                    <option value="NA">Choose...</option>
                                                    {atariData.map((item, index) => (
                                                        <option key={index} value={item.ataricode}>
                                                            {item.atariname}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        )}
                                        
                                       {/* Address */}
                                       <div className='col-md-4'>
                                            <label className="form-label">Address</label><label style={{color : "red"}}>*</label>
                                            <input 
                                                placeholder='Address' 
                                                type='text' 
                                                className='form-control' 
                                                onChange={(e) => handleAddress(e)} 
                                                value={addressValue} 
                                                maxLength={350} 
                                            />
                                        </div>
                                        {/* <div className='col-md-4'>
                                            <label className="form-label">State Name</label><label style={{color : "red"}}>*</label>
                                            <select 
                                                className='form-select' 
                                                value={stateValue}
                                                onChange={(e) => setStateValue(e.target.value)}
                                            > 
                                                <option value={"NA"}>Choose...</option>
                                                {statesData.map((item, id) => {
                                                    return (
                                                        <option key={id} value={item.stateCode}>
                                                            {item.stateName}
                                                        </option>
                                                    );
                                                })}
                                            </select>
                                        </div>
                                        
                                       
                                        <div className='col-md-4'>
                                            <label className="form-label">District Name</label><label style={{color : "red"}}>*</label>
                                            <select 
                                                className='form-select' 
                                                value={districtValue}
                                                onChange={(e) => setDistrictValue(e.target.value)}
                                                disabled={!stateValue || stateValue === "NA"}
                                            >
                                                <option value="NA">Choose...</option>
                                                {districtsData.map((item, index) => {
                                                    return (
                                                        <option key={index} value={item.districtCode}>
                                                            {item.districtName}
                                                        </option>
                                                    );
                                                })}
                                            </select>
                                        </div> */}
                                        
                                        {/* User Name */}
                                        <div className='col-md-4'>
                                            <label className="form-label">User Name</label><label style={{color : "red"}}>*</label>
                                            <input 
                                                placeholder='User Name' 
                                                type='text' 
                                                className='form-control' 
                                                onChange={(e) => handleUserName(e)} 
                                                value={userNameValue} 
                                                maxLength={50}
                                                autoComplete="off"
                                            />
                                        </div>
                                        
                                        {/* Designation */}
                                        <div className="col-md-4">
                                            <label htmlFor="Designation" className="form-label">
                                              Designation
                                            </label><label style={{color : "red"}}>*</label>
                                            <select
                                              id="Designation"
                                              required
                                              className="form-select"
                                              onChange={(e) => setDesignationValue(e.target.value)}
                                              value={designationValue}
                                            >
                                              <option defaultValue>Choose...</option>
                                              {designationData.map((item, id) => {
                                                return (
                                                  <option key={id} value={item.desigCode}>
                                                    {item.desigName}
                                                  </option>
                                                );
                                              })}
                                            </select>
                                        </div>
                                        
                                        {/* Mobile No */}
                                        <div className="col-md-4">
                                            <label htmlFor="mobileNo" className="form-label">
                                              Mobile No
                                            </label><label style={{color : "red"}}>*</label>
                                            <input
                                              type="text"
                                              className="form-control"
                                              id="mobilenumber"
                                              required
                                              placeholder="Mobile No."
                                              onChange={(e) => handleMobileNumber(e.target.value)}
                                              value={mobileValue}
                                              onKeyUp={validateMobile}
                                              maxLength="10"
                                              readOnly={state ? true : false}
                                            />
                                        </div>
                                        
                                       

                                        {/* Email Id */}
                                        <div className="col-md-4">
                                            <label htmlFor="emailId" className="form-label">
                                              Email Id
                                            </label>
                                            <input
                                              type="email"
                                              className="form-control"
                                              id="emailId"
                                              placeholder="Email Id"
                                              onChange={(e) => handleEmail(e)}
                                              value={emailValue}
                                            />
                                        </div>
                                   
                                     {/* Gender */}
                                     <div className="col-md-6">
                                            <div className="col-md-12">
                                              <label htmlFor="gender" className="form-label">
                                                Gender
                                              </label><label style={{color : "red"}}>*</label>
                                            </div>
                                            <div className="col-md-12">
                                              <div
                                                className="form-check form-check-inline"
                                                onClick={() => {
                                                  setGender("M");
                                                }}
                                              >
                                                <input
                                                  className="form-check-input"
                                                  type="radio"
                                                  name="gender"
                                                  id="inlineRadio1"
                                                  value="male"
                                                  checked={gender === "M"}
                                                />
                                                <label
                                                  className="form-check-label"
                                                  htmlFor="inlineRadio1"
                                                >
                                                  Male
                                                </label>
                                              </div>
                                              <div
                                                className="form-check form-check-inline"
                                                onClick={() => {
                                                  setGender("F");
                                                }}
                                              >
                                                <input
                                                  className="form-check-input"
                                                  type="radio"
                                                  name="gender"
                                                  id="inlineRadio2"
                                                  value="female"
                                                  checked={gender === "F"}
                                                />
                                                <label
                                                  className="form-check-label"
                                                  htmlFor="inlineRadio2"
                                                >
                                                  Female
                                                </label>
                                              </div>
                                              <div
                                                className="form-check form-check-inline"
                                                onClick={() => {
                                                  setGender("T");
                                                }}
                                              >
                                                <input
                                                  className="form-check-input"
                                                  type="radio"
                                                  name="gender"
                                                  id="inlineRadio3"
                                                  value="transgender"
                                                  checked={gender === "T"}
                                                />
                                                <label
                                                  className="form-check-label"
                                                  htmlFor="inlineRadio3"
                                                >
                                                  Other
                                                </label>
                                              </div>
                                            </div>
                                          </div>
                                          </div>
                                    {/* Action Buttons */}
                                    <div className="d-grid gap-2 d-md-flex justify-content-md-center mt-4">
                                        {state ? (
                                          <button
                                            className="btn btn-success me-md-2"
                                            type="button"
                                            onClick={ValidateAddUser}
                                          >
                                            Update Atari User
                                          </button>
                                        ) : (
                                          <button
                                            className="btn btn-success me-md-2"
                                            type="button"
                                            onClick={() => {
                                              console.log("Create Atari User button clicked");
                                              ValidateAddUser();
                                            }}
                                          >
                                            Create Atari User
                                          </button>
                                        )}

                                        <button
                                          className="btn btn-outline-danger"
                                          type="button"
                                          onClick={() => navigate("/MNT/UsrListMnt")}
                                        >
                                          Cancel
                                        </button>
                                      </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
            <AdminFooterNew /> 
        </>
    );
};
 
export default AtariUserCreation; 